import { useEffect, useReducer, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useTemplatesContext } from "../../context/templatesContext";

export const useSearchParamsToReducer = ({
	searchData,
}: {
	searchData: Function;
}) => {
	const [shouldSearch, refetch] = useReducer((x) => x + 1, 0);
	const [searchParams, setSearchParams] = useSearchParams();
	const isMountRef = useRef(true);

	const {
		state: { firstTime, searchAssetIdToTable },
		actions,
	} = useTemplatesContext();

	useEffect(() => {
		let shouldUpdate = false;
		if (searchParams.has("search")) {
			const search = searchParams.get("search");
			actions.setSearchText(search);
			shouldUpdate = true;
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		} else if (firstTime) {
			refetch();
			actions.setFirstTime(false);
		}
	}, [searchParams]);

	useEffect(() => {
		if (!isMountRef.current) {
			searchData();
		}
		isMountRef.current = false;
	}, [shouldSearch, searchAssetIdToTable]);
};
